import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { DBDef_Book } from '@app/hcs-shared';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
export const dispatch_onBooksUpdated = new ThunderDispatcherV3('__onBooksUpdated');
export class ModuleFE_Book_Class extends ModuleFE_BaseApi {
    constructor() {
        super(DBDef_Book, dispatch_onBooksUpdated);
    }
}
export const ModuleFE_Book = new ModuleFE_Book_Class();
//# sourceMappingURL=ModuleFE_Book.js.map